import { equalsIgnoreCase } from 'src/utilities/StringUtilities';
import { Box } from '@mui/material';

export const isPitchContract = (contract) => {
  if (!contract) return false;
  if (typeof contract.isPitch === 'boolean') return contract.isPitch;
  const id = contract.netsuiteId || '';
  return typeof id === 'string' && id.startsWith('PITCH-');
};

const Dot = ({ color = 'success.main' }) => (
  <Box component="span" sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: color, display: 'inline-block' }} />
);

export const renderStatusDot = (statusOption) => {
  const isPitch = isPitchContract(statusOption);
  const hasNsId = !!statusOption?.netsuiteId && !isPitch;
  const hasServiceType = !!statusOption?.serviceType && !equalsIgnoreCase(statusOption?.serviceType ?? '', 'No Service Type');
  const isMissingNetsuiteId = !hasNsId;
  const isMissingServiceType = !hasServiceType;
  const inactive = equalsIgnoreCase(statusOption?.serviceStatus ?? '', 'Inactive');

  if (isPitch) {
    return <Dot color="info.light" />;
  } else if (isMissingNetsuiteId || isMissingServiceType) {
    return <Dot color="warning.main" />;
  } else if (inactive) {
    return <Dot color="error.main" />;
  } else {
    return <Dot color="success.main" />;
  }
};

export const getContractTextStatus = (contract) => {
  const isPitch = isPitchContract(contract);
  const hasNsId = !!contract?.netsuiteId && !isPitch;
  const hasServiceType = !!contract?.serviceType && !equalsIgnoreCase(contract?.serviceType ?? '', 'No Service Type');
  const isMissingNetsuiteId = !hasNsId;
  const isMissingServiceType = !hasServiceType;
  const inactive = equalsIgnoreCase(contract?.serviceStatus ?? '', 'Inactive');

  if (isPitch) {
    return 'Pitch';
  }
  if (isMissingNetsuiteId && isMissingServiceType) {
    return 'Missing contract and service type';
  }
  if (isMissingNetsuiteId) {
    return 'Missing signed contract';
  }
  if (isMissingServiceType) {
    return 'Missing service type';
  }
  if (inactive) {
    return 'Inactive';
  }
  return 'Active';
};
